<mat-form-field
    appearance="outline"
    subscriptSizing="dynamic">
    <input
        #input
        class="!bg-white"
        matInput
        type="text"
        [formControl]="columnControl"
        [matAutocomplete]="auto"
        [placeholder]="'identifierColumn' | transloco"
        (focus)="filterColumnList()"
        (input)="filterColumnList()" />
    <mat-autocomplete
        #auto="matAutocomplete"
        requireSelection="true"
        (optionSelected)="columnSelection.emit($event.option.value)">
        @for (column of filteredColumnsList; track $index) {
            <mat-option [value]="column.name">
                {{ column.name }}
            </mat-option>
        }
    </mat-autocomplete>
</mat-form-field>
